export const USER_ROLES = ['REQUESTER', 'BIDDER', 'ADMIN'] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const BIDDER_TYPES = ['INDIVIDUAL', 'COMPANY'] as const;
export type BidderType = (typeof BIDDER_TYPES)[number];
